<script>
  export default {
    methods: {
      postHit(type) {
        this.$store.commit('Modals/hide', 'hit_post_bar')
        this.$store.commit('Modals/show', 'hit_' + type)
      }
    }
  }
</script>

<template>
  <nav class="level box">
    <b-tooltip class="level-item" label="">
      <a class="has-text-centered" @click="postHit('image')">
        <img src="../../assets/img/icon_image.svg">
        <span v-once>{{ $t('feed.throw_image') }}</span>
      </a>
    </b-tooltip>
    
    <b-tooltip class="level-item" :label="$t('infotitle.hit_code')" position="is-bottom" type="is-light">
      <a class="has-text-centered" @click="postHit('code')">
        <img src="../../assets/img/icon_code.svg">
        <span v-once>{{ $t('feed.throw_code') }}</span>
      </a>
    </b-tooltip>
    
    <b-tooltip class="level-item" :label="$t('infotitle.hit_video')" position="is-bottom" type="is-light">
      <a class="has-text-centered" @click="postHit('video')">
        <img src="../../assets/img/icon_video.svg">
        <span v-once>{{ $t('feed.throw_video') }}</span>
      </a>
    </b-tooltip>
    
    <b-tooltip class="level-item" label="">
      <a class="has-text-centered" @click="postHit('link')">
        <img src="../../assets/img/icon_link.svg">
        <span v-once>{{ $t('feed.throw_link') }}</span>
      </a>
    </b-tooltip>
  </nav>
</template>

<style lang="scss" scoped>
  @import '~bulma/sass/utilities/all';

  .level {
    display: flex;
    padding-left: 0;
    padding-right: 0;
  }

  .level-item {
    flex: 1 1 25%;
    width: 25%;
    color: #000;

    a {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      color: inherit;
    }

    &:not(:last-child) a:after {
      content: ' ';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 1px;
      background: rgba(0, 0, 0, 0.2);
    }
  }

  img {
    height: 30px;
    margin-bottom: pxToEm(10);
  }
</style>



// WEBPACK FOOTER //
// HitPostBar.vue?e7a66a0a